<template>
  <v-sheet elevation="0" class="ma-2 px-2 h85" v-if="suite">
    <v-row class="mb-5">
      <v-col>
        <BackBtn to="/suites" />
      </v-col>
      <!-- <Title
        v-model="suite.name"
        empty="Insert a new Suite name..."
        icon="package-variant"
        editable
      />
      <v-spacer></v-spacer> -->
    </v-row>
    <v-card class="ma-1 pa-1" elevation="4">
      <v-row class="ma-1">
        <v-col class="pa-2 scrollable h70">
          <v-row class="mt-1">
            <v-col>
              <h4><v-icon>mdi-cog-outline</v-icon> General:</h4>
            </v-col>
          </v-row>
          <v-row class="my-1">
            <v-col>
              <v-text-field
                v-model="suite.name"
                label="Suite Name"
                :rules="rules.text"
                required
                dense
              >
              </v-text-field>
            </v-col>
            <v-divider vertical> </v-divider>
            <v-col>
              <v-row class="mt-1">
                <v-col cols="auto">
                  <v-switch class="my-0" color="success" v-model="suite.active">
                  </v-switch>
                </v-col>
                <v-col cols="auto">
                  <h4 class="my-1"><v-icon>mdi-power</v-icon> Active</h4>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-divider> </v-divider>
          <v-row class="mt-1">
            <v-col>
              <h4>
                <v-icon>mdi-application-variable-outline</v-icon>
                Suite Global Variables:
              </h4>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <EnvSettings v-model="suite" @input="suiteChanged" />
            </v-col>
          </v-row>
          <v-divider> </v-divider>
          <v-row class="mt-1" v-if="suite._id">
            <v-col>
              <v-text-field
                v-model="suite._id"
                disabled
                label="Test Suite Identifier"
                required
              >
              </v-text-field>
            </v-col>
            <v-col cols="auto">
              <CopyToClip :text="suite._id" />
            </v-col>
          </v-row>
        </v-col>
        <v-divider vertical> </v-divider>
        <v-col class="pa-2 scrollable h70">
          <v-row class="justify-center mt-1">
            <v-col cols="auto">
              <v-btn-toggle v-model="selected" mandatory>
                <v-btn color="info" text small outlined value="plans">
                  <v-icon color="info" size="20">mdi-flask-outline</v-icon>
                  Test Cases
                </v-btn>
                <!-- <v-btn color="purple" text small outlined value="routines">
                  <v-icon color="purple" size="20">mdi-cog-clockwise</v-icon>
                  Routines
                </v-btn> -->
                <v-btn color="orange" text small value="suites">
                  <v-icon color="orange" size="20">mdi-package-variant</v-icon>
                  Suites
                </v-btn>
              </v-btn-toggle>
            </v-col>
          </v-row>
          <section v-if="suite.plans || suite.suites">
            <v-row>
              <!-- <v-col>
                <v-select
                  :items="selectMethods"
                  v-model="selected"
                  label="Select Method"
                  outlined
                  @change="fetchMethod"
                  dense
                  hide-details
                >
                  <template v-slot:item="{ item }">
                    <v-icon small class="pr-1">mdi-{{ item.icon }}</v-icon>
                    {{ item.text }}
                  </template>
                </v-select>
              </v-col> -->
              <v-col>
                <v-autocomplete
                  :items="items"
                  v-model="selectedList"
                  :label="'Search & Select test ' + selected"
                  outlined
                  clearable
                  multiple
                  dense
                  return-object
                  prepend-icon=""
                >
                </v-autocomplete>
              </v-col>
              <!-- <v-col>
                <v-combobox
                  :items="items"
                  v-model="selectedList"
                  :label="'Search & Select test ' + selected"
                  outlined
                  clearable
                  multiple
                  dense
                  prepend-icon=""
                >
                </v-combobox>
              </v-col> -->
            </v-row>
            <DragList :list="selectedList" @changed="updateList">
              <template v-slot:title>
                <v-icon small>mdi-order-bool-ascending-variant</v-icon> Test
                {{ selected }} Order:
              </template>
            </DragList>
          </section>
          <!-- <v-col>
              <h4><v-icon>mdi-flask-outline</v-icon> Test Cases:</h4>
            </v-col>
          </v-row>
          <section v-if="suite.plans">
            <v-row>
              <v-col>
                <v-combobox
                  :items="plans"
                  v-model="suite.plans"
                  label="Search & Select Test Case"
                  outlined
                  clearable
                  multiple
                  dense
                >
                </v-combobox>
              </v-col>
            </v-row>
            <DragList :list="suite.plans" @changed="updateList">
              <template v-slot:title>
                <v-icon>mdi-order-bool-ascending-variant</v-icon> Test Cases Order:
              </template>
              <template v-slot:icon>
                <v-icon>mdi-flask</v-icon>
              </template>
            </DragList>
          </section> -->
        </v-col>
      </v-row>
    </v-card>
    <v-row>
      <v-spacer> </v-spacer>
      <v-col cols="auto">
        <v-btn
          class="ma-3"
          :disabled="!valid"
          label="Save"
          color="success"
          @click="save"
        >
          <v-icon dark> mdi-content-save </v-icon> Save
        </v-btn>
      </v-col>
    </v-row>
  </v-sheet>
</template>

<script lang="ts">
import Vue from "vue";

import BackBtn from "../components/buttons/BackBtn.vue";
// import Title from "../components/Title.vue";
import DragList from "../components/DragList.vue";
import CopyToClip from "@/components/CopyToClip.vue";
import { Plan, SelectItem, Suite } from "@/types";
import { cloneObj, permissions } from "@/utils";
import EnvSettings from "@/components/EnvSettings.vue";

export default Vue.extend({
  name: "SuiteView",
  components: {
    BackBtn,
    DragList,
    CopyToClip,
    EnvSettings,
  },
  data() {
    return {
      rules: {
        text: [
          (val: string) => (val && val.length) || "This field is required",
        ],
      },
      selected: "plans",
      // selectMethods: [
      //   {
      //     text: "Test Case",
      //     value: "plans",
      //     icon: "flask",
      //   },
      //   {
      //     text: "Test Routine",
      //     value: "routines",
      //     icon: "cog-clockwise",
      //   },
      //   {
      //     text: "Test Suite",
      //     value: "suites",
      //     icon: "package-variant",
      //   },
      // ],
    };
  },
  computed: {
    valid(): boolean {
      return (
        this.suite?.name?.length > 0 &&
        (this.suite?.plans?.length > 0 || this.suite?.suites?.length > 0)
      );
    },
    suite: {
      get(): Suite {
        const suite: Suite = this.$store.getters["Suites/getCurrentSuite"];
        this.$store.commit(
          "setTitle",
          suite._id ? `Edit '${suite.name}'` : "Add New Suite"
        );
        // this.fixObj(suite, "Suite");
        return suite;
      },
      set(val: Suite) {
        this.suiteChanged(val);
      },
    },
    // plans(): SelectItem[] {
    //   // TODO
    //   const plans = this.$store.getters["Plans/getPlans"];

    //   return plans.map((p: Plan): SelectItem => {
    //     return { text: p.name, value: p._id, icon: "flask" };
    //   });
    // },
    selectedList: {
      get(): SelectItem[] {
        return this.suite[this.selected];
      },
      set(items: SelectItem[]) {
        this.suite[this.selected] = items;
      },
    },
    selectedIcon(): string {
      let icon = "package-variant";
      switch (this.selected) {
        case "plans":
          icon = "flask";
          break;
        case "routines":
          icon = "cog-clockwise";
          break;
        case "suites":
          icon = "package-variant";
          break;

        default:
          break;
      }
      return icon;
    },

    items(): SelectItem {
      const funcText = { suites: "Suites/getSuites", plans: "Plans/getPlans" };
      const items = this.$store.getters[funcText[this.selected]];

      return items.map((item: Plan | Suite) => {
        if (item._id !== this.suite._id) {
          return {
            text: item.name,
            value: item._id,
            icon: this.selectedIcon,
          };
        }
      });
    },
    hasHeaders(): boolean {
      return this.suite.headers && Object.keys(this.suite.headers).length > 0;
    },
    hasEnv(): boolean {
      return this.suite.env?.length > 0;
    },
    premissionList() {
      return permissions.filter((p) =>
        this.suite.permissions ? this.suite.permissions.indexOf(p) < 0 : true
      );
    },
  },
  methods: {
    removePlan(index: number) {
      this.suite.plans.splice(index, 1);
    },
    updateList(list: SelectItem) {
      this.suite[this.selected] = list;
      this.suiteChanged({ [this.selected]: list });
    },
    suiteChanged(newData: Suite | undefined = undefined) {
      if (newData) {
        const suite: Suite = this.suite;
        for (const key in newData) {
          suite[key] = cloneObj(newData[key]);
        }
      }
      this.$store.commit("Suites/setCurrentSuite", this.suite);
    },
    save() {
      // modify plans list to string[]
      // const plans = this.suite.plans.map((s: SelectItem) => s.value);
      const items = [
        ...this.suite[this.selected].map((s: SelectItem) => s.value),
      ];
      this.suite[this.selected] = items;
      this.selected == "plans"
        ? (this.suite.suites = [])
        : (this.suite.plans = []);
      this.$store.dispatch("Suites/saveSuite", this.suite);
      this.$store.commit("Suites/setCurrentSuite", {});
      this.$router.push("/suites");
    },
  },

  async mounted() {
    this.$store.commit("setGlobalLoader", true);
    this.$store.commit("Suites/setCurrentSuite");
    // TODO filter
    // const filter = {};
    this.$store.dispatch("Plans/fetchAllPlans", {
      sort: { name: 1 },
      type: { '$lte': 1 },
    });
    this.$store.dispatch("Suites/fetchSuites");
    const { id } = this.$route.params;
    if (id) {
      await this.$store.dispatch("Suites/fetchCurrentSuite", id);
      this.suite.plans.length
        ? (this.selected = "plans")
        : (this.selected = "suites");
    }
    this.$store.commit("setGlobalLoader");
  },
  destroyed() {
    this.$store.commit("Suites/setCurrentSuite");
  },
});
</script>
